import { useEffect, useState } from "react";
import { IOption } from "../../../../AdobeAriaLib/AdobeSelect";
import { httpGet } from "../../../../../modules/Backend";
import AdobeComboBox from "../../../../AdobeAriaLib/AdobeComboBox";
import { Button } from "react-aria-components";
import IconBin from "../../../../../assets/icons/icon-bin-red.svg"
import IconPlus from "../../../../../assets/icons/icon-plus-blue.svg"
import IconPlusDisabled from "../../../../../assets/icons/icon-plus-grey.svg"
import { useLocation } from "react-router-dom";
import * as Navigation from "../../../../../modules/Navigation";

interface IFormAccountRole {
    value: IAccountRole[],
    onChange: Function,
    parentId: string
}

interface IAccountRole {
    accountId?: string
    roleId?: string
}

export default function FormAccountRole({ value, onChange, parentId }: IFormAccountRole) {
    const { pathname } = useLocation();
    const [accounts, setAccounts] = useState<IOption[]>([])
    const [roles, setRoles] = useState<IOption[]>([])

    async function GetOptions() {
        var result = await httpGet("api/users/accountRoles")
        if (result.data?.accounts && result.data?.roles) {
            setAccounts(result.data.accounts)
            setRoles(result.data.roles)
        }
    }

    async function HandleChange(accountId: string | undefined, roleId: string | undefined, i: number) {
        const newValue = [...value]
        newValue[i].accountId = accountId
        newValue[i].roleId = roleId
        onChange(newValue)
    }

    async function HandleRemove(i: number) {
        const newValue = [...value]
        newValue.splice(i, 1)
        onChange(newValue)
    }

    async function HandleAdd() {
        const newValue = [...value]
        newValue.push({ accountId: undefined, roleId: undefined } as IAccountRole)
        onChange(newValue)
    }

    useEffect(() => {
        GetOptions()
    }, [])

    useEffect(() => {
        if (parentId) {
            const isCreate = pathname.includes(Navigation.create.to)
            if (isCreate) {
                onChange([{ accountId: parentId, roleId: undefined } as IAccountRole])
            }
        }
    }, [parentId])

    return (
        <div>
            <hr />
            <h2>Roles & Permissions</h2>
            <div className="grid-x alignItems--end margin__top--s row-gap--s">
                {value.map((x, i) => (<>
                    <div className="cell small-5 padding__right--s">
                        <AdobeComboBox
                            value={x.accountId}
                            label={"Account"}
                            labelVisible={true}
                            options={accounts.filter(y => !value.map(z => z.accountId).includes(y.value) || y.value == x.accountId)}
                            required={false}
                            onChangeSelect={(accountVal: any) => HandleChange(accountVal, x.roleId, i)}
                            disabled={false}
                            selectionMode="single" />
                    </div>
                    < div className="cell small-5 padding__right--s" >
                        <AdobeComboBox
                            value={x.roleId}
                            label={"Role"}
                            labelVisible={true}
                            options={roles}
                            required={false}
                            onChangeSelect={(roleVal: any) => HandleChange(x.accountId, roleVal, i)}
                            disabled={false}
                            selectionMode="single" />
                    </div>
                    < div className="cell small-2 " >
                        <Button className={"button button--secondary button--secondary--destructive button--with-icon button--large"} onPress={() => HandleRemove(i)}>
                            <img src={IconBin}></img>
                            <p className="button-text button-text--small">Remove</p>
                        </Button>
                    </div>
                </>)
                )}
                <div className="cell small-3 " >
                    <Button className={"button button--secondary button--with-icon button--large"} onPress={() => HandleAdd()} isDisabled={value.length >= accounts.length}>
                        <img src={value.length < accounts.length ? IconPlus : IconPlusDisabled}></img>
                        <p className="button-text button-text--small">Add account</p>
                    </Button>
                </div>
            </div>
        </div >
    )
}